import i18n from "lib/i18n";
import moment from "moment";
import PropTypes from "prop-types";

const LastEditedBy = ({ date, name }) => {
  if (!date || !name) { return ""; }

  const formattedLastEditedDate = moment(date).format("MMMM Do, YYYY");
  return i18n.t("comment_manager.dialog.last_edited_by", {
    date: formattedLastEditedDate,
    name,
  });
};

LastEditedBy.defaultProps = {
  date: "",
  name: "",
};

LastEditedBy.propTypes = {
  date: PropTypes.string,
  name: PropTypes.string,
};

export default LastEditedBy;
